import {
  BUY_TYPES,
  GUESS_TYPES,
  SPECIAL_QUEST_TYPES,
  SUBSCRIBE_TYPES,
  FAVOURITE_TYPES,
  ADD_TO_CART_TYPES,
} from '../../../constants/tasksTypes'
import { useContent } from '../../../redux/reducer/content'
import { challengeTaskUid } from '../../../constants/shared/ids/challengeTaskUid'

export const useQuestFlags = ({ quest }) => {
  const { id, type } = quest
  const { quests } = useContent()

  const isSubscribeTask = SUBSCRIBE_TYPES.includes(type)
  const isGuessTask = GUESS_TYPES.includes(type)
  const isBuyTask = BUY_TYPES.includes(type)
  const isFavouriteTask = FAVOURITE_TYPES.includes(type)
  const isSpecialQuestTask = SPECIAL_QUEST_TYPES.includes(type)
  const isAddToCartTask = ADD_TO_CART_TYPES.includes(type)

  const isChallenge = (quests ?? []).some(({ uid, subQuests = [] } = {}) => {
    const isInsideSubQuests = subQuests?.some(({ id: questId }) => questId === id)
    const isChallengeTaskUid = uid === challengeTaskUid

    return isInsideSubQuests && isChallengeTaskUid
  })

  return {
    isSubscribeTask,
    isGuessTask,
    isBuyTask,
    isFavouriteTask,
    isSpecialQuestTask,
    isChallenge,
    isAddToCartTask,
  }
}
